/**
 * Design tokens as JS strings — for cases where we need to pass an oklch
 * value into JS (inline style merging, canvas, etc). CSS variables in
 * globals.css are the primary source of truth; this mirrors them.
 */
export const T = {
  cream: 'oklch(97% 0.012 75)',
  creamMid: 'oklch(93% 0.018 75)',
  creamBorder: 'oklch(87% 0.022 75)',
  espresso: 'oklch(18% 0.018 60)',
  espressoMid: 'oklch(38% 0.022 60)',
  espressoLight: 'oklch(58% 0.018 60)',
  terra: 'oklch(62% 0.13 48)',
  terraLight: 'oklch(92% 0.04 65)',
  terraMid: 'oklch(78% 0.07 55)',
  terraDeep: 'oklch(48% 0.14 45)',
  sage: 'oklch(62% 0.08 152)',
  sageLight: 'oklch(92% 0.03 152)',
  white: 'oklch(99% 0.005 75)',
  ink: 'oklch(12% 0.01 60)',
  danger: '#c0392b',
} as const;
